const app = {
  name: 'PMIS',
  desc: 'Project Management Information System',
  fullname: 'Departemen Infrastruktur II',
  company: 'PT Adhi Karya (Persero) Tbk.',
  guide: 'https://drive.google.com/drive/folders/1jBWqGf9Px1PNv_vv4saIr1tGjyUb9PsV?usp=sharing',
  site: 'https://adhi.co.id',
  code: 'adhi-pmis',
  logo: {
    sm: './static/img/logo/240x240.png',
    md: './static/img/logo/480x480.png',
    lg: './static/img/logo/720x720.png'
  },
  server: {
    stagging: '/api/',
    development: 'https://pmis-v2.pttas.net/api/',
    production: 'https://pmis.adhi-info.com/api/',
    demo: 'https://pmis-v2.pttas.net/api/'
  },
  sso: {
    stagging: 'https://pmis-v2.pttas.net/api/',
    development: 'https://pmis-v2.pttas.net/api/',
    production: '?????',
    demo: 'https://pmis-v2.pttas.net/api/'
  },
  download: {
    android: 'https://play.google.com/store/',
    ios: 'https://www.apple.com/id/app-store/'
  },
  options: {
    allowRegister: false,
    forgetPassword: true,
    autofill: false,
    myAction: true,
    asideRight: false,
    sso: false
  }
}

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app



// WEBPACK FOOTER //
// ./src/config.js